var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1128 11L17.7525 4.27754C17.847 4.16582 17.7675 3.99609 17.6214 3.99609H15.907C15.806 3.99609 15.7093 4.04121 15.6427 4.11855L10.9913 9.66367L6.33997 4.11855C6.27551 4.04121 6.17883 3.99609 6.07571 3.99609H4.36126C4.21516 3.99609 4.13567 4.16582 4.2302 4.27754L9.86985 11L4.2302 17.7225C4.20903 17.7474 4.19544 17.7778 4.19106 17.8102C4.18668 17.8426 4.19168 17.8756 4.20548 17.9052C4.21928 17.9348 4.24129 17.9599 4.2689 17.9774C4.29652 17.9949 4.32857 18.0041 4.36126 18.0039H6.07571C6.17669 18.0039 6.27337 17.9588 6.33997 17.8814L10.9913 12.3363L15.6427 17.8814C15.7072 17.9588 15.8038 18.0039 15.907 18.0039H17.6214C17.7675 18.0039 17.847 17.8342 17.7525 17.7225L12.1128 11Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.53191d6f.svg";
export { ForwardRef as ReactComponent };